'use strict';/* global define, console*/define('modules/dispatcher/services/dispatcher/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$rootScope", "Console"];
function factory($rootScope,Console){// jshint validthis:true
// jshint latedef:false
return{dispatch:dispatch};// ---
/**
     * Dispatch an event to all listeners
     *
     * @param  {String}          eventName - The name of the event that will be
     *                                     	 dispatched
     * @param  {Array|undefined} args      - Possible agruments that will be
     *                                     	 passed to the
     *                                     	 callback function
     */function dispatch(eventName,args){if(arguments.length<1){return Console.warn('Please provide at least the event name as a parameter!');}$rootScope.$broadcast.call($rootScope,eventName,args);}}module.exports=factory;});
